import aside from '@/components/aside/menuList';
import {service as http} from '@/utils/request';
import { Loading } from 'element-ui';
let directData = {},permission = null;
/**
 *  将 aside 数据导入directData
 */
(()=> {
  let arr = aside;
  if(arr.length) {
    arr.forEach(item1 => {
      if(item1.group[0].id) {
        item1.group.forEach(item2 => {
          directData[item2.link.split('/')[1]] = {
            parent:item1.name,
            name:item2.name,
          }
        })
      }
    });
  }
})();
export default {
    state: {
      asideData: aside,//菜单
      direct:[],//面包屑
      permission: null,//权限
    },
    mutations: {
      //更新菜单栏权限
      UPDATEDASIDEDATA: (state) => {
        state.asideData.map(val => {
          val.show = state.permission[val.code];
          if(val.group[0].id) {//下层是有效菜单 暂时只考虑第二层
            val.group.map(_val => {
              _val.show = state.permission[_val.code]
            })
          }
        });
      },
      //更新权限
      UPDATEPERMISSION:(state, newVal)=>{
        const arr = {};
        newVal.map(val => {
          arr[`${val.substring(0,4)}`] = Number(val.substring(4,5)) === 1;
        });
        state.permission = arr;
      },
      //删除权限
      DELETEPERMISSION:(state)=>{
        state.permission = null;
      },
      //更新面包屑
      UPDATEDIRECT : (state, newValue ) => {
        state.direct = newValue;
      },
      PUSHDIRECT(state, newValue ){
        state.direct.push(newValue);
      },
      POPDIRECT(state, newValue ){
        state.direct.pop();
      }
    },
    actions: {
      updatedPermission( { commit ,state }) {
        return new Promise((resolve, reject) => {
          let loadingInstance = Loading.service();
          http.get(`/resource/getEnablingResourceKey`)
            .then(res => {
              commit('UPDATEPERMISSION', res.data);
              loadingInstance.close();
              resolve();
            }).catch(err => {
              loadingInstance.close();
              reject(err);
            })
        } )
      },
      updateDirect( { commit, state }, nav) {
        if(nav) {
          let moduleList = nav.split('/');
          // console.log(directData)
          let moduleObj = directData[moduleList[1]];
          if(moduleObj) {
            commit('UPDATEDIRECT',[moduleObj['parent'],moduleObj['name']])
          }
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/store/modules/data.js